import { useDrawer } from '@cast/design-system';

import { CatalogueItem } from './constants';
import { DefinitionDrawer } from './DefinitionDrawer';

export const useDefinitionDrawer = () => {
  const { open } = useDrawer();
  return {
    openDefinitionDrawer: ({ item }: { item: CatalogueItem }) => {
      open({
        component: DefinitionDrawer,
        props: {
          item,
        },
      });
    },
  };
};
